<template>
  <div class="row q-pt-sm q-pb-sm q-pr-sm q-mb-xs cursor-pointer">
    <input
      :checked="modelValue === value"
      class="full-width absolute cursor-pointer"
      :name="name"
      type="radio"
      :value="value"
      @change="$event.target.checked && $emit('update:modelValue', value)"
    />
    <div
      class="radio-circle"
      :class="{ selected: modelValue === value }"
    />
    <label class="radio-label">
      <slot>
        {{ label }}
      </slot>
    </label>
  </div>
</template>

<script>
export default {
  name: "RadioCircle",
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [Boolean, Object],
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
};
</script>

<style lang="scss" scoped>
input[type="radio"] {
  height: 22px;
  opacity: 0;
  z-index: 10;
}

.radio-circle {
  margin-right: 25px;
  width: 22px;
  height: 22px;
  background: transparent;
  border-radius: 100%;
  position: relative;
  border: 1px solid $soft-grey;

  &.selected {
    border: 1px solid $primary;

    &::before {
      content: "";
      position: absolute;
      top: 25%;
      left: 25%;
      width: 50%;
      height: 50%;
      background: $primary;
      border-radius: 100%;
    }
  }
}

.radio-label {
  line-height: 22px;
  word-break: break-word;
  flex: 1;
}
</style>
